import React from "react";

function Icon({ fillHover }) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='99'
			height='99'
			fill='none'
			viewBox='0 0 99 99'>
			<mask
				id='mask0_228_680'
				style={{ maskType: "luminance" }}
				width='61'
				height='51'
				x='19'
				y='24'
				maskUnits='userSpaceOnUse'>
				<path fill='#fff' d='M19.206 24.75h60.456v49.358H19.206V24.75z'></path>
			</mask>
			<g mask='url(#mask0_228_680)'>
				<path
					className={fillHover}
					d='M79.421 49.601c-5.53 4.656-9.256 6.346-9.256 6.346s-9.104-3.574-14.376-7.324c-.29-.207.12 2.01 4.4 5.979 2.09 1.938 4.239 3.547 5.815 5.425.678.812 1.112 1.78 1.259 2.346.218.84.55 2.256-.022 3.854-.605 1.697-1.572 2.697-3.272 3.39-1.858.759-4.134.302-5.23-.286-1.033-.552-1.92-1.31-2.478-1.958-.099-.114-.184-.212-.261-.304.077 1.243.387 2.56 1.325 3.716.596.732 1.73 1.556 2.532 2.088l-8.749-.005c.965-.7 2.284-1.847 2.803-2.772.836-1.483.814-2.962.814-2.962s-2.122 2.936-5.627 2.936c-3.875 0-5.93-2.894-5.93-5.4 0-5.007 3.388-6.249 9.679-12.371 2.917-2.842 4.006-7.074 4.006-7.074s-13.776-.028-16.384 2.385c-.54-3.84 3.356-8.803 6.678-10.337.318-.147-.27 6.295-.27 6.295l7.41-8.215-.292 7.488 6.795-6.452-1.695 7.338S69.742 37.403 71 31.29c.147-.714.293-.801-.143-1.14-3.678-2.871-10.595-6.46-19.274-5.104-9.003 1.407-13.496 6.408-15.655 8.839 0 0-2.967-.853-4.08-1.044-6.934-1.18-12.937 2.997-12.604 3.177 6.834 3.702 12.279 5.785 12.109 6.457-1.46 5.764-.943 8.464-.68 10.02-7.782 5.842-6.86 10.51-6.673 10.434 3.834-1.524 9.106-2.413 9.222-2.196 5.69 10.602 15.88 12.64 16.795 12.784a.285.285 0 00.103-.025c1.69.342 3.419.525 5.18.525 1.85 0 3.666-.2 5.442-.578l.022.013s2.276-.461 4.152-1.302c1.882-.842 3.554-3.19 4.566-6.343.224-.696.476-1.38.757-2.052a24.282 24.282 0 011.47-2.94c.69-1.18 1.326-2.453 2.368-3.348 5.417-4.645 5.617-8.094 5.343-7.866h.002zm-31.228-21.67c3.64 1.657 7.523 2.673 7.523 2.673s-3.931.268-6.837 1.676c-.21.101-.303-.072-.447-.272-1.62-2.264-.389-4.145-.239-4.077z'></path>
			</g>
		</svg>
	);
}

export default Icon;
